import * as React from 'react';
import { Box, Typography, SkipTrackingProvider, Icon } from '@drone-js/core';

var DATE_SELECTED_COLOR = 'base.default';
var DATE_NOT_SELECTED_COLOR = 'base.subtle';
var SingleSelectedDateDisplay = function SingleSelectedDateDisplay(_ref) {
  var titleLabel = _ref.titleLabel,
    formattedDate = _ref.formattedDate,
    dateIsSelected = _ref.dateIsSelected;
  var textColor = dateIsSelected ? DATE_SELECTED_COLOR : DATE_NOT_SELECTED_COLOR;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flex: 3,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption-default",
    textColor: "base.subtle",
    mb: "4"
  }, titleLabel), /*#__PURE__*/React.createElement(Typography, {
    variant: "body-s-strong",
    textColor: textColor
  }, formattedDate));
};
var PLACEHOLDER_DATE_STRING = '-';
var SelectedDateDisplay = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var startDateItems = _ref2.startDateItems,
    endDateItems = _ref2.endDateItems,
    placeholderDate = _ref2.placeholderDate,
    id = _ref2.id;
  var placeholderDateDisplay = placeholderDate || PLACEHOLDER_DATE_STRING;
  var startDate = startDateItems.selectedDate,
    startDateTitle = startDateItems.titleLabel;
  var endDate = endDateItems.selectedDate,
    endDateTitle = endDateItems.titleLabel;
  return /*#__PURE__*/React.createElement(SkipTrackingProvider, null, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    ref: ref,
    width: "100%",
    p: "8",
    id: id
  }, /*#__PURE__*/React.createElement(SingleSelectedDateDisplay, {
    dateIsSelected: !!startDate,
    titleLabel: startDateTitle,
    formattedDate: startDate !== null && startDate !== void 0 ? startDate : placeholderDateDisplay
  }), /*#__PURE__*/React.createElement(Icon, {
    id: "fill.arrow.thin-right",
    color: DATE_NOT_SELECTED_COLOR,
    size: "24",
    mx: "4"
  }), /*#__PURE__*/React.createElement(SingleSelectedDateDisplay, {
    dateIsSelected: !!endDate,
    titleLabel: endDateTitle,
    formattedDate: endDate !== null && endDate !== void 0 ? endDate : placeholderDateDisplay
  })));
});

export { SelectedDateDisplay };
//# sourceMappingURL=SelectedDateDisplay.js.map
